import _ from 'lodash';
import savePurcashingAccountsComponent from './../savePurchasingAccounts/savePurchasingAccounts.component';

class PurchasingAccountsController {

  constructor(purchasingAccountsService, customerIntegrationsService, modalLoaderService, contentLoaderService) {
    this.name = 'purchasingAccounts';
    this.orgHierarchy = [];
    this.alertConfig = {
      type: 'success',
      msg: ''
    };
    this.showAlert = false;
    this.contentLoaderService = contentLoaderService;
    this.customerIntegrationsService = customerIntegrationsService;
    this.purchasingAccountsService = purchasingAccountsService;
    this.modalLoaderService = modalLoaderService;
    this.reset();
  }

  getPurchasingAccounts(organization) {
    return new Promise((resolve) => {
      this.purchasingAccountsService.getPurchasingAccounts(organization.xid).then((response) => {
        const purchasingAccounts = response && response.data || [];
        this.cachedPurchasingAccounts = purchasingAccounts.reduce((acc, {
          name,
          oracleAccountId,
          encryptedConnectedId
        }) => {
          const id = encryptedConnectedId;
          if (!acc[id]) {
            acc[id] = {
              id,
              name,
              organizations: [],
              dedupeOrg: {},
              oracleAccountId: oracleAccountId || 'NON-OKS',
            };
            if(!acc[id].dedupeOrg[organization.xid]){
              acc[id].dedupeOrg[organization.xid] = 1;
              acc[id].organizations.push(organization);
            }
          } else if (acc[id]) {
            acc[id].name = !acc[id].name ? name : acc[id].name;
            if (!acc[id].dedupeOrg) {
              acc[id].dedupeOrg = {};
            }
            if (!acc[id].dedupeOrg[organization.xid]) {
              acc[id].organizations.push(organization);
              acc[id].dedupeOrg[organization.xid] = 1;
            }
          }
          return acc;
        }, Object.assign({}, this.cachedPurchasingAccounts));
        this.purchasingAccounts = Object.values(this.cachedPurchasingAccounts);
        this.processed++;
        resolve();
      }).catch((error) => {
        console.trace(error);

        this.processed++;
        console.log(error && error.data && error.data.message);
        resolve();
      });
    });

  }

  getExistingAccountsAndOrgHierarchy() {
    if (this.customer && this.customer.id) {
      this.selectedPurchasingAccounts = [];
      this.isLoading = true;
      this.processed = 0;
      Promise.all([
        this.purchasingAccountsService.getPurchasingAccountsByCustomerId(this.customer.id),
        this.customerIntegrationsService.getAllIntegrations({
          customerId: this.customer.id
        }),
        this.purchasingAccountsService.getOrgHierarchy(this.customer.id)
      ]).then(([purchasingAccountsResponse, customerIntegrationsResponse, orgHierarchyResponse]) => {
        const customerIntegrations = customerIntegrationsResponse && customerIntegrationsResponse.data && customerIntegrationsResponse.data.content || [];
        // CACHE EXISTING CUSTOMER INTEGRATIONS
        this.existingcustomerIntegrations = customerIntegrations.reduce((acc, {
          key,
          value
        }) => {
          acc[value] = value;
          if (key === 'orgXid' && value) {
            this.orgXid = value;
          }
          if (key === 'orgId' && value) {
            this.orgId = value;
          }
          if (key === 'purchasingAccountNumber' && value && !this.selectedPurchasingAccounts.includes(value)) {
            this.selectedPurchasingAccounts.push(value);
            this.existingPurchasingAccounts.push(value);
          }
          return acc;
        }, {});
        const purchasingAccounts = purchasingAccountsResponse && purchasingAccountsResponse.data || [];
        // BUILD ACCOUNTS FROM EXISTING PURCHASING ACCOUNTS
        this.cachedPurchasingAccounts = purchasingAccounts.reduce((acc, {
          oksAccountNumber,
          purchasingAccountName,
          purchasingAccountNumber
        }) => {
          /// Purchasing Accounts Exists IN AM but Removed from ROSES
          if (!acc[purchasingAccountNumber] && this.existingcustomerIntegrations[purchasingAccountNumber]) {
            acc[purchasingAccountNumber] = {
              organizations: [],
              id: purchasingAccountNumber,
              name: purchasingAccountName,
              oracleAccountId: oksAccountNumber,
            };
          } else if(acc[purchasingAccountNumber]){
            acc[purchasingAccountNumber].name = !acc[purchasingAccountNumber].name ? purchasingAccountName: acc[purchasingAccountNumber].name;
          }
          return acc;
        }, this.cachedPurchasingAccounts);
        this.purchasingAccounts = Object.values(this.cachedPurchasingAccounts);
        const orgHierarchy = orgHierarchyResponse && orgHierarchyResponse.data || [];
        this.orgHierarchy = orgHierarchy || [];
        // SET DISTRICT ORG
        this.districtOrg = _.find(orgHierarchy, (org) => this.orgXid && org.xid === this.orgXid || this.orgId && org.uuid === this.orgId);
        // FETCH ACCCONTS
        Promise.all(_.map(orgHierarchy, (org) => this.getPurchasingAccounts(org))).finally(() => {
          this.isLoading = false;
          this.contentLoaderService.hide();
        });
      }).catch((error) => {
        this.onFailure(error && error.data && error.data.message || 'No org found');
        this.isLoading = false;
        this.contentLoaderService.hide();
      });
    }
  }

  onFailure(msg) {
    window.scrollTo(0, 0);
    this.alertConfig.type = 'danger';
    this.alertConfig.msg = msg;
    this.showAlert = true;
  }


  updatePurchasingAccounts(e, cmd) {
    const id = e.target.value;
    switch (id) {
    case 'all': {
      switch (cmd) {
      case 'remove':
        this.selectedPurchasingAccounts = [];
        this.removePurchasingAccounts = this.existingPurchasingAccounts;
        break;
      case 'add':
        this.selectedPurchasingAccounts = [...new Set([...this.selectedPurchasingAccounts, ...this.purchasingAccounts.map((purchasingAccount) => purchasingAccount.id)])];
        break;
      }
      break;
    }
    default: {
      switch (cmd) {
      case 'remove':
        this.selectedPurchasingAccounts = this.selectedPurchasingAccounts.filter(a => {
          return a !== id;
        });
        if (!this.removePurchasingAccounts.includes(id) && this.existingcustomerIntegrations[id]) {
          this.removePurchasingAccounts.push(id);
        }
        break;
      case 'add':
        this.removePurchasingAccounts = this.removePurchasingAccounts.filter(a => {
          return a !== id;
        });
        if (!this.selectedPurchasingAccounts.includes(id)) {
          this.selectedPurchasingAccounts.push(id);
        }
        break;
      }
      break;
    }
    }
  }

  buildCustomerIntegrations({
    accounts = [],
    isRemove = false,
    isAdd = false
  }) {
    return accounts.reduce((acc, id) => {
      if (isAdd && !this.existingcustomerIntegrations[id] || isRemove && this.existingcustomerIntegrations[id]) {
        const account = this.cachedPurchasingAccounts[id];
        if (account) {
          acc.push({
            value: account.id,
            type: 'ConnectEd',
            customerId: this.customerId,
            key: 'purchasingAccountNumber',
          });
        }
      }
      return acc;
    }, []);
  }

  savePurchasingAccounts() {
    let customerIntegrationsToAdd = [];
    if (this.selectedPurchasingAccounts && this.selectedPurchasingAccounts.length) {
      customerIntegrationsToAdd = this.buildCustomerIntegrations({
        isAdd: true,
        accounts: this.selectedPurchasingAccounts,
      });
    }
    this.modalLoaderService.show(savePurcashingAccountsComponent, {
      reset: this.reset.bind(this),
      purchasingAccounts: {
        customer: this.customer,
        cachedPurchasingAccounts: this.cachedPurchasingAccounts,
        selectedPurchasingAccounts: this.selectedPurchasingAccounts.filter(a => !this.existingcustomerIntegrations[a]),
        removePurchasingAccounts: this.removePurchasingAccounts.filter(a => this.existingcustomerIntegrations[a]),
        customerIntegrationsToAdd
      }
    }, 'purchasingAccountsModal__modal');
  }

  reset() {
    this.isManual = _.toLower(this.customer.rosterType) === 'manual';
    if (!this.isManual) {
      this.processed =  0;
      this.isLoading = false;
      this.purchasingAccounts = null;
      this.cachedPurchasingAccounts = {};
      this.selectedPurchasingAccounts = [];
      this.removePurchasingAccounts = [];
      this.existingcustomerIntegrations = {};
      this.existingPurchasingAccounts = [];
      this.contentLoaderService.show();
      this.getExistingAccountsAndOrgHierarchy();
    } else {
      this.processed = 1;
      this.isLoading = false;
      this.purchasingAccounts = [];
    }
  }
}

PurchasingAccountsController.$inject = ['purchasingAccountsService', 'customerIntegrationsService', 'modalLoaderService', 'contentLoaderService'];

export default PurchasingAccountsController;



// WEBPACK FOOTER //
// ./app/components/purchasingAccounts/purchasingAccounts.controller.js